<div class="card border-0 my-5 me-1 me-lg-5">
  <div *ngIf="informationalOnly; else purchase">
    <a class="card-text" href="{{this.informationalUrl}}" target="_blank">
      <app-catalog-graphic imageClasses="card-img-top border"
                           [imageId]="imageId"
                           [imageSize]="160">
      </app-catalog-graphic>
      <h5 class="card-title text-primary pt-3"><strong>{{ name }}</strong></h5>
    </a>
  </div>
  <ng-template #purchase>
    <a [routerLink]="['/product', id]">
      <app-catalog-graphic imageClasses="card-img-top border"
                           [imageId]="imageId"
                           [imageSize]="160">
      </app-catalog-graphic>
      <h5 class="card-title text-primary pt-3"><strong>{{ name }}</strong></h5>
    </a>
  </ng-template>
  <ul class="card-body py-0 px-0">
    <li *ngFor="let platform of availablePlatforms"
        class="border d-inline-block py-1 px-1 me-1 mb-1">
      <app-platform
        class="mx-2"
        [platform]="platform"></app-platform>
    </li>
  </ul>
  <div *ngIf="informationalOnly; else prices">
    <div class="card border-0 me-1 me-lg-5">
      <p class="card-text pt-0 price">
        Informational Only
      </p>
    </div>
  </div>
  <ng-template #prices>
    <p class="card-text pt-0 price" *ngIf="hasOfferings">
      <app-price [lowestPrice]="lowestPrice" [highestPrice]="highestPrice"></app-price>
    </p>
  </ng-template>
</div>
